import {
  formatDateNoTime,
  formatYDM,
  getToken,
  getToken2,
  getUser,
  numberFormatInt,
} from "../../Utils/Common"
import Moment from "moment"
import { getAPICall, postAPICall } from "../axiosMethodCalls"
import { Category } from "@mui/icons-material"

export const getOrder = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/get_order",
      {
        requester: getUser(),
        token: getToken(),
        order_id: data.id,
        transaction_type: data.type,
        added_on_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : "",
        added_on_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : "",
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getAllOrder = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/get_all_order",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const searchOrder = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/search",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: data.branch_id,
        branch_name: data.branch_name,
        payment_type: data.mode,
        status: data.status,
        order_id: data.order_id,
        transaction_type: data.type,
        added_on_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        added_on_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const searchOrderByBranch = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/sales_per_branch",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: data.branch_id,
        group_by_date: data.group_by_date,
        branch_name: data.branch_name,
        transaction_type: data.type,
        added_on_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        added_on_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteOrder = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/delete",
      {
        requester: getUser(),
        token: getToken(),
        order_id: id,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const updateVoidRequest = async (
  branch_id,
  order_id,
  status,
  remarks
) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/void_request_update",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: branch_id,
        order_id: order_id,
        status: status,
        remarks: remarks,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getSalesPerProduct = async (data) => {
  try {
    const response = await getAPICall(
      //   process.env.REACT_APP_LINK + "orders/sales_per_product",
      process.env.REACT_APP_LINK + "reports/top_selling",
      {
        requester: getUser(),
        token: getToken(),
        category: data.category_id, 
        item: data.item_id,
        branch_id: data.branch_id,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        page: data.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getStoreDiscountReport = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/orders_w_discount",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: data.branch_id,
        transaction_type: data.transaction_type,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        page: data.page,
      }
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getSinkers = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "price_levels/get_price_level",
      {
        requester: getUser(),
        token: getToken(),
        price_level_id: id,
        is_add_on: 1,
      }
    )
    return { data: response }
  } catch (error) {
    //
    return { error: error.response }
  }
}

export const getAllAddOrderData = async (branch_id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_LINK + "orders/get_order_details",
      {
        requester: getUser(),
        token: getToken(),
        branch_id: branch_id,
        // price_level_id: id,
        // is_add_on: 1
      }
    )
    return { data: response }
  } catch (error) {
    //
    return { error: error.response }
  }
}

export const createOrder = async (data, orders) => {
  var array = [...orders]
  array.map((data, dataindex) => {
    var addon_id = []
    var addon_names = []
    var addon_prices = []
    var addon_qtys = []

    data.sinkers.map((sink, sinkindex) => {
      if (sink.sinker_qty !== 0) {
        addon_id.push(sink.id)
        addon_names.push(sink.whole_name)
        addon_prices.push(sink.price)
        addon_qtys.push(sink.sinker_qty)
      }

      array[dataindex]["addon_ids"] = addon_id
      array[dataindex]["addon_names"] = addon_names
      array[dataindex]["addon_prices"] = addon_prices
      array[dataindex]["addon_qtys"] = addon_qtys
    })
  })

  try {
    var payload = {
      requester: getUser(),
      token: getToken(),
      branch_id: data.branch_id,
      date: Moment(data.date).format("YYYY-MM-DD"),
      price_level_id: data.price_level_id,
      price_level_type_id: data.price_level_type_id,
      proof: data.proof,
      reference_no: data.reference_no,
      payment_type: "credit",
      gift_cert_code: data.gift_cert_code,
      discount_code: data.code,
      delivery_fee: data.delivery_fee,
      remarks: data.remarks,
      subtotal: data.subtotal,
      paid_amount: data.grand_total,
      grand_total: data.grand_total,
      or_no: data.or_no,
      price_level_type_name: data.transaction_type,

      product_ids: orders.map((item) => {
        return item.product_id
      }),
      product_names: orders.map((item) => {
        return item.product_name
      }),
      product_prices: orders.map((item) => {
        return item.price
      }),
      quantities: orders.map((item) => {
        return item.qty
      }),
      order_detail_remarks: orders.map((item) => {
        return item.remarks
      }),
      addon_ids: array.map((item) => {
        return item.addon_ids
      }),
      addon_names: array.map((item) => {
        return item.addon_names
      }),
      addon_prices: array.map((item) => {
        return item.addon_prices
      }),
      addon_qtys: array.map((item) => {
        return item.addon_qtys
      }),

      discount: data.active_discount,
      additional_discount: data.additional_discount,
      discount_ids: data.discount_id,
      names: data.names,
      discount_prices: data.discount_prices,
    }

    const response = await postAPICall(
      process.env.REACT_APP_LINK + "orders/create",
      payload
    )
    //
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

// ------------POTATO---------------------------
//FOR MANAGE TABLE
export const searchOrderByBranchPotato = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "orders/sales_per_branch",
      {
        requester: getUser(),
        token: getToken2(),
        branch_id: data.branch_id,
        group_by_date: data.group_by_date,
        branch_name: data.branch_name,
        transaction_type: data.type,
        added_on_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        added_on_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

//FOR VIEWING AN ORDER
export const searchOrderPotato = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "orders/search",
      {
        requester: getUser(),
        token: getToken2(),
        branch_id: data.branch_id,
        branch_name: data.branch_name,
        payment_type: data.mode,
        status: data.status,
        order_id: data.order_id,
        transaction_type: data.type,
        added_on_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        added_on_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const deleteOrderPotato = async (id) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "orders/delete",
      {
        requester: getUser(),
        token: getToken2(),
        order_id: id,
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getSalesPerProductPotato = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "orders/sales_per_product",
      {
        requester: getUser(),
        token: getToken2(),
        product_id: data.product_id,
        branch_id: data.branch_id,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}

export const getStoreDiscountReportPotato = async (data) => {
  try {
    const response = await getAPICall(
      process.env.REACT_APP_POTATO + "orders/orders_w_discount",
      {
        requester: getUser(),
        token: getToken2(),
        branch_id: data.branch_id,
        transaction_type: data.transaction_type,
        date_from: data.date_from
          ? Moment(data.date_from).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
        date_to: data.date_to
          ? Moment(data.date_to).format("YYYY-MM-DD")
          : Moment().format("YYYY-MM-DD"),
      },
      "potato"
    )
    return { data: response.data }
  } catch (error) {
    return { error: error }
  }
}
